import React from "react";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { inMiniProgram, navigateStack } from "utils/WeChatUtil";

import "./CookieBar.scss";
import i18n from "utils/I18n";

const WechatCookieBar = ({
  showCookieBar,
  rejectAction,
  agreeAction,
}) => {
  const isInMiniProgram = inMiniProgram();
  const history = useHistory()

  return <>
    {isInMiniProgram && showCookieBar ?  (
      <div className="wechat-cookie-bar subheading" >
        <div>
          <Trans i18nKey={"cookie_text_wechat"} >
            <label
              className="text_link"
              onClick={() => navigateStack({ fullLink: `${process.env.REACT_APP_TERM_CONDITIONS_LINK}?lang=${i18n.language}`, history })}
            />
            <label
              className="text_link"
              onClick={() => navigateStack({ fullLink: `${process.env.REACT_APP_PRIVACY_LINK}?lang=${i18n.language}`, history })}
            />
          </Trans>
        </div>
        <div className="home_cookie_buttonArea">
          <Button
            className="buttonArea_reject button-large"
            onClick={rejectAction}
          >
            {i18n.t("reject")}
          </Button>
          <Button
            className="buttonArea_accept button-large"
            onClick={agreeAction}
          >
            {i18n.t("agree")}
          </Button>
        </div>
      </div>
    ) : null}</>
  }

const mapStateToProps = (state) => ({
  agreeCookiePolicy: state.users.agreeCookiePolicy,
  recheckCookie: state.users.recheckCookie,
});

export default withTranslation()(connect(mapStateToProps)(WechatCookieBar));
